import Head from 'next/head';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useRouter } from 'next/router';

import '../styles/blogpage.css';
import Container from 'app/components/common/Container';
import Metatag from 'app/components/metaTag';
import { TERMS_AND_CONDITION } from 'app/helpers/apiEndpoint';
import REQUEST from 'app/helpers/http.service';
import './termsconditions.css';

export default function TermsAndConditions({ res }) {
  const { termcondition } = JSON.parse(res);
  const { asPath } = useRouter();
  const router = useRouter();
  const canonicalUrl = (
    `${process.env.NEXT_PUBLIC_BASE_URL}` +
    (router.asPath === '/' ? '' : router.asPath)
  ).split('?')[0];

  return (
    <div className="md:mt-[80px] mt-[70px] lg:py-[55px] py-[25px] roboto">
      <Head>
        <title>{termcondition?.Seo?.metaTitle}</title>
        <meta
          name="description"
          content={termcondition?.Seo?.metaDescription}
        />

        <meta property="og:title" content={termcondition?.Seo?.metaTitle} />
        <meta
          property="og:description"
          content={termcondition?.Seo?.metaDescription}
        />

        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_BASE_URL}${asPath}`}
        />

        <Metatag
          content={termcondition?.Seo?.metaImage?.data?.attributes?.url}
          pageUrl={canonicalUrl}
        />
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <Container className="term-condition">
        {termcondition?.title && (
          <h1 className="text-[#00102B] font-[800] xl:text-[55px] md:text-[32px] text-[25px] leading-tight lg:mb-[55px] md:mb-[35px] mb-[25px]">
            {termcondition?.title}
            <span className="block w-[120px] h-[6px] bg-[#0050D5]"></span>
          </h1>
        )}
        {termcondition?.descriptionEditor && (
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            className={`text-[#383838] md:text-[22px] text-[16px] font-[400] leading-tight`}
            source={termcondition?.descriptionEditor}
          >
            {termcondition?.descriptionEditor}
          </ReactMarkdown>
        )}
      </Container>
    </div>
  );
}

export async function getStaticProps() {
  const [termcondition] = await Promise.all([
    REQUEST({
      method: 'GET',
      url: TERMS_AND_CONDITION,
    }),
  ]);
  const res = JSON.stringify({
    termcondition: termcondition?.data?.data?.attributes,
  });
  return {
    props: { res },
  };
}
